<template>
  <div>
    <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
      <v-card color="primary" dark>
        <v-card-text>
          {{progressMessage}}
          <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogAddEdit" max-width="1000px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{addEditHeader}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0"
                    outlined
                    name="input-7-4"
                  :label="$t('รหัสการสั่งตรวจ')"
                  v-model="newTestItemID"
                  :disabled="isEdit"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field class="ma-0 pa-0" 
                  outlined
                  name="input-7-4"
                  :label="$t('ชื่อการสั่งตรวจ')"
                  v-model="newTestItemDesc"
                ></v-text-field>
              </v-col> 
              <v-col cols="12" sm="12" md="2">
                <v-select
                  class="ma-0 pa-0"
                  outlined
                  hide-details
                  :label="$t('WpProbe.type')"
                  v-model="newCode_p_type"
                  :items="['PB', 'PG']"
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field class="ma-0 pa-0"
                  outlined
                  name="input-7-4"
                  :label="$t('ชื่อเล่น')"
                  v-model="newNickName"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select :items="subCategoryList" v-model="lab_sub_category_skey" item-text="sub_category_desc" item-value="sub_category_skey"
                  :label="$t('WpLabRequest.lablaboratory')" persistent-hint single-line outlined dense hide-details>
                </v-select>
              </v-col> 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn outlined color="success" @click="addTestItem(newTestItemID,newTestItemDesc,newNickName,lab_sub_category_skey,newCode_p_type)">{{$t('save')}}</v-btn>
            <v-btn outlined color="error" @click="closeAddnew">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogAddResultItem" max-width="1000px" max-height="80%" eager>\
      <v-card flat>
        <v-card-title>
          <v-toolbar dense flat color="white">
            <v-toolbar-title>{{$t('Add Test Item')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>
        <v-data-table
          v-model="vDataTableResultItem.selected"
          :headers="resultItemHeaders"
          :items="vDataTableResultItem.data"
          :search="vDataTableResultItem.search"
          fixed-header
          :page.sync="vDataTableResultItem.options.page"
          :itemsPerPage.sync="vDataTableResultItem.options.itemsPerPage"
          :options.sync="vDataTableResultItem.options"
          :footer-props="{
            itemsPerPageText: $t('itemsPerPageText'),
            itemsPerPageAllText: $t('itemsPerPageAllText'),
            showFirstLastPage: true,
            showCurrentPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          item-key="test_item_skey"
          class="fill-height"
          @click:row="addResultToTest"
          >
        </v-data-table>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogAddProbe" max-width="1000px" max-height="80%" eager>\
      <v-card flat>
        <v-card-title>
          <v-toolbar dense flat color="white">
            <v-toolbar-title>{{ headerMassage }}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>
        <v-data-table
          v-model="vDataTableProbe.selected"
          :headers="addProbeHeaders"
          :items="vDataTableProbe.data"
          :search="vDataTableProbe.search"
          fixed-header
          :page.sync="vDataTableProbe.options.page"
          :itemsPerPage.sync="vDataTableProbe.options.itemsPerPage"
          :options.sync="vDataTableProbe.options"
          :footer-props="{
            itemsPerPageText: $t('itemsPerPageText'),
            itemsPerPageAllText: $t('itemsPerPageAllText'),
            showFirstLastPage: true,
            showCurrentPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
          }"
          item-key="test_item_skey"
          class="fill-height"
          @click:row="addProbeToTest"
          >
        </v-data-table>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.dialogAddprobeConfirm" max-width="1000px" eager>
      <v-card>
        <v-card-title>
          <span class="headline">{{'เพิ่ม ' + headerMassage}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field class="ma-0 pa-0"
                  hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('Price')"
                  v-model="addProbePrice"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field class="ma-0 pa-0" 
                  hide-details
                  outlined
                  name="input-7-4"
                  :label="$t('Remark')"
                  v-model="addProbeRemark"
                ></v-text-field>
              </v-col> 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn outlined color="success" @click="addProbeToTestConfirm()">{{$t('save')}}</v-btn>
            <v-btn outlined color="error" @click="closeAddProbe">{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table
      v-model="vDataTable.selected"
      :headers="headers"
      :items="vDataTable.data"
      :search="vDataTable.search"
      fixed-header
      :page.sync="vDataTable.options.page"
      :itemsPerPage.sync="vDataTable.options.itemsPerPage"
      :options.sync="vDataTable.options"
      :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
      :footer-props="{
        itemsPerPageText: $t('itemsPerPageText'),
        itemsPerPageAllText: $t('itemsPerPageAllText'),
        showFirstLastPage: true,
        showCurrentPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
      item-key="test_item_skey"
      class="fill-height"
      show-expand single-expand
    >
      <template v-slot:item.data-table-no="{ item, index }">
        {{index + 1}}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="background-color: #f0f0f0; padding: 3;">
          <v-card class="ma-3" style="overflow-x: auto; ">
            <v-tabs>
            <v-tab style="text-transform: capitalize">{{$t('Result Item')}}</v-tab>
              <v-tab-item>
                <v-data-table
                  fixed-header
                  :headers="addResultItemHeaders"
                  :items="item.result_items"
                  class="elevation-1"
                  hide-default-footer
                  style="margin: auto;"
                  dense>
                  <template v-slot:item.actions="{ item: result_items }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="red" small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deleteTestResultItem(result_items, item)">delete</v-icon>
                      </template>
                      <span>delete</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:top>
                    <v-toolbar flat>
                      <!-- <v-toolbar-title>Result Item</v-toolbar-title> -->
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                      <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newResultItem(item)">
                        <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('WpTestItem.buttonNewResultItem')}}
                      </v-btn>
                    </v-toolbar>
                  </template>
                </v-data-table>
              </v-tab-item>
              <v-tab style="text-transform: capitalize">{{$t('WpTestItem.probePathogen')}}</v-tab>
              <v-tab-item>
                <v-data-table
                  fixed-header
                  :headers="probeHeaders"
                  :items="item.probes"
                  class="elevation-1"
                  hide-default-footer
                  style="margin: auto;"
                  dense>
                  <template v-slot:item.actions="{ item: probes }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon color="red" small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deleteTestProbe(probes, item)">delete</v-icon>
                      </template>
                      <span>delete</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:top>
                    <v-toolbar flat>
                      <!-- <v-toolbar-title>Result Item</v-toolbar-title> -->
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                      <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newProbe(item)">
                        <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>
                        {{ item.code_p_type === 'PB' ? $t('WpTestItem.addProbe') : item.code_p_type === 'PG' ? $t('WpTestItem.addPathogen') : '' }}
                      </v-btn>
                    </v-toolbar>
                  </template>
                </v-data-table>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </td>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="teal" class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="pink" class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{$t('WpTestItem.testItemTitle')}}</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-divider class="mx-1" inset vertical></v-divider>
          <!-- <v-btn outlined color="primary" style="text-transform: capitalize" @click="ImportExcelToDbConfirm()">
            {{$t('import')}}
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="ExportExcelLab">
            {{$t('export excel')}}
          </v-btn>
          <v-divider class="mx-1" inset vertical></v-divider>    -->
          <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newItem()">
            <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>{{$t('WpTestItem.buttonNewTestItem')}}
          </v-btn>
          <!-- <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
            <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>{{$t('WpTestItem.buttonDeleteTesetItem')}}
          </v-btn> -->
          <v-divider class="mx-1" inset vertical></v-divider>
          <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveWpTestItem(appName)">
            <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field outlined dense hide-details v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapState } from 'vuex'
import Base64Binary from 'base64-arraybuffer'
import { VueEditor, Quill } from 'vue2-editor'
/* import { consoleLog } from '../node_modules-/echarts/lib/util/log' */
var Keyboard = Quill.import('modules/keyboard')
class CustomKeyboard extends Keyboard {
  static DEFAULTS = {
    ...Keyboard.DEFAULTS,
    bindings: {
      ...Keyboard.DEFAULTS.bindings,
      ['list autofill']: undefined,
    }
  }
}
Quill.register('modules/keyboard', CustomKeyboard)
export default {
  components: {
    VueEditor,
  },

  props: ['parentComponent'],

  data () {
    return {
      utils: require('@/utils'),
      stringFormat: require('string-format'),
      appName: process.env.VUE_APP_DB_APP_NAME,
      rules: {
        winName: value => {
          const pattern = /^[a-zA-Z0-9$@$!%*?&#^-_. +]+$/
          return pattern.test(value) || 'Invalid Window Name'
        },
      },
      dialog: {
        dialogProgress: false,
        dialogAddEdit: false,
        dialogLanguage: false,
        dialogAddOrderItem: false,
        dialogAddResultItem: false,
        dialogAddProbe: false,
        dialogAddprobeConfirm: false,
      },
      vDataTable: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      vDataTableResultItem: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      vDataTableProbe: {
        search: '',
        selected: [],
        data: [],
        editedIndex: -1,
        editedItem: {
          win_name: '',
          window_comment: ''
        },
        defaultItem: {
          win_name: '',
          window_comment: ''
        },
        editedLanguageIndex: -1,
        editedLanguageItem: {
        },
        defaultLanguageItem: {
        },
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          sortDesc: [],
          groupBy: [],
          groupDesc: true,
          multiSort: true,
          // mustSort: true
        },
        expanded: [],
      },
      subCategoryList: [],
      progressMessage: '',
      languages: [],
      languageEdit: true,
      vueEditorOrganGross: 'vue-editorOrganGrossCustomHeight200',
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        /* [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], */
        /* [{ list: 'ordered' }, { list: 'check' }], */
        /* [{ indent: '-1' }, { indent: '+1' }], */
        [{ color: [] }],
        ['clean']
      ],
      editorSettings: {
        fomats: [
          'background',
          'bold',
          'color',
          'font',
          'code',
          'italic',
          'link',
          'size',
          'strike',
          'script',
          'underline',
          'blockquote',
          'header',
          'indent',
          'align',
          'direction',
          'code-block',
          'formula',
          'image',
          'video'
        ],
      },
      sheets: [],
      file: '',
      selectedFile: null,
      laboratoryList: [],
      // add new order item
      newNickName: '',
      newTestItemID: '',
      newTestItemDesc: '',
      lab_sub_category_skey: '',
      current_test_item_skey: '',
      isEdit: false,
      addedProbeCd: '',
      addProbePrice: '',
      addProbeRemark: '',
      headerMassage: '',
      newCode_p_type: '',
    }
  },
  computed: {
    ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
    formLanguageTitle () {
      return this.vDataTable.editedLanguageIndex === -1 ? this.$t('WpOrderItem.newOrderItemLanguage') : this.$t('WpOrderItem.editOrderItemLanguage')
    },
    headers () {
      return [
        // { text: '', align: 'center', value: 'data-table-select' },
        { text: '#', align: 'left', value: 'data-table-no', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpTestItem.testItemId'), value: 'test_item_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpTestItem.testItemDesc'), value: 'test_item_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpTestItem.nickname'), value: 'nickname', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpTestItem.code_p_type'), value: 'code_p_type', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('WpTestItem.sub_category_desc'), value: 'sub_category_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    resultItemHeaders () {
      return [
        { text: this.$t('Test Item Skey'), value: 'result_item_skey', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Test Item ID'), value: 'result_item_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Test Item Desc'), value: 'result_item_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    probeHeaders () {
      return [
        { text: this.$t('Seq'), value: 'seq', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Code'), value: 'probe_cd', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Description'), value: 'probe_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Price'), value: 'price', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    addProbeHeaders () {
      return [
        { text: this.$t('Seq'), value: 'seq', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Code'), value: 'probe_cd', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Description'), value: 'probe_desc', align: 'left', class: 'text-xl-left body-1 black--text' }
      ]
    },
    addResultItemHeaders () {
      return [
        { text: this.$t('Seq'), value: 'seq', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('actions'), value: 'actions', sortable: false, class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Result Item Skey'), value: 'result_item_skey', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Result Item ID'), value: 'result_item_id', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('Result Item Desc'), value: 'result_item_desc', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('nickname'), value: 'nickname', align: 'left', class: 'text-xl-left body-1 black--text' },
        { text: this.$t('alias_id'), value: 'alias_id', align: 'left', class: 'text-xl-left body-1 black--text' },
      ]
    },
    subHeaders () {
      return [
        { text: this.$t('navWindow.windowName'), value: 'win_name' },
        { text: this.$t('createUser'), value: 'create_user_id' },
      ]
    },
    offsetAppBar () {
      // return this.getShowAppBar ? 0 : this.getAppBarHeight
      return this.getShowAppBar ? this.getAppBarHeight : 0
    },
  },
  async created () {
    await this.retrieveWpTestItem(this.appName)
    await this.retrieveWpResultItem(this.appName)
    await this.retrieveCategory(this.appName)
  },
  mounted () {
  },
  updated () {
  },
  methods: {
    async retrieveWpTestItem () {
      console.log('retrieveWpTestItem')
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/testItem/retrieveWpTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
        cust_skey: localStorage.getItem('cust_skey')
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTable.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async retrieveWpResultItem (appName) {
      console.log('retrieveOrderItem')
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      await this.axios.post(process.env.VUE_APP_API + '/testItem/retrieveWpResultItem' + process.env.VUE_APP_DATABASE_TYPE, {
        cust_skey: localStorage.getItem('cust_skey')
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.vDataTableResultItem.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      this.dialog.dialogProgress = false
    },
    async retrieveProbe (codePType) {
      // this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      this.headerMassage = codePType === 'PB' ? this.$t('WpTestItem.probe') : this.$t('WpTestItem.pathogen')
      await this.axios.post(process.env.VUE_APP_API + '/wp_probe/retrieveProbe' + process.env.VUE_APP_DATABASE_TYPE, {
        code_p_type: codePType
      })
        .then(response => {
          console.log('response.data', response.data)
          if (response.data.isSuccess) {
            this.vDataTableProbe.data = response.data.data
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      // this.dialog.dialogProgress = false
    },
    newResultItem (item) {
      this.dialog.dialogAddResultItem = true
      this.current_test_item_skey = item.test_item_skey
    },
    async newProbe (item) {
      await this.retrieveProbe(item.code_p_type)
      this.dialog.dialogAddProbe = true
      this.current_test_item_skey = item.test_item_skey
    },
    newItem () {
      this.addEditHeader = this.$t('WpTestItem.addHeader')
      this.newTestItemID = ''
      this.newTestItemDesc = ''
      this.newNickName = ''
      this.lab_sub_category_skey = ''
      this.isEdit = false
      this.dialog.dialogAddEdit = true
    },
    async addTestItem (newTestItemID, newTestItemDesc, newNickName, subCategorySkey, codePType) {
      if (!newTestItemID) {
        await this.$swal({type: 'error', title: this.$t('WpTestItem.idMissing')})
        return
      }
      if (!newTestItemDesc) {
        await this.$swal({type: 'error', title: this.$t('WpTestItem.descMissing')})
        return
      }
      if (!newNickName) {
        await this.$swal({type: 'error', title: this.$t('WpTestItem.nicknameMissing')})
        return
      }
      if (!subCategorySkey) {
        await this.$swal({type: 'error', title: this.$t('WpTestItem.categoryMissing')})
        return
      }
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      if (this.isEdit === false) {
        await this.axios.post(process.env.VUE_APP_API + '/testItem/addTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
          test_item_id: newTestItemID,
          test_item_desc: newTestItemDesc,
          nickname: newNickName,
          sub_category_skey: subCategorySkey,
          code_p_type: codePType,
          user: localStorage.getItem('username')
        })
        .then(response => {
          if (response.data.isSuccess) {
            if (response.data.data[0].reasonValue === 1) {
              this.retrieveWpTestItem()
              this.$swal({type: 'success', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
              this.dialog.dialogAddEdit = false
            } else {
              this.$swal({type: 'error', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
            }
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      } else {
        await this.axios.post(process.env.VUE_APP_API + '/testItem/editTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
          test_item_id: newTestItemID,
          test_item_desc: newTestItemDesc,
          nickname: newNickName,
          sub_category_skey: subCategorySkey,
          code_p_type: codePType,
          user: localStorage.getItem('username')
        })
        .then(response => {
          if (response.data.isSuccess) {
            if (response.data.data[0].reasonValue === 1) {
              this.retrieveWpTestItem()
              this.$swal({type: 'success', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
              this.dialog.dialogAddEdit = false
            } else {
              this.$swal({type: 'error', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
            }
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      }
      this.dialog.dialogProgress = false
    },
    closeAddnew () {
      this.dialog.dialogAddEdit = false
    },
    async retrieveCategory (methodcode) {
      await this.axios.post(process.env.VUE_APP_API + '/retrieveCategory' + process.env.VUE_APP_DATABASE_TYPE, {
        Lotskey: methodcode
      })
        .then(response => {
          if (response.data.isSuccess) {
            this.subCategoryList = response.data.data
            // this.appSkey = response.data.data.length > 0 ? response.data.data[0]['Lotskey'] : -1
            // this.vDataTableCate.data = response.data.data
            // this.initialize()
            // })
          } else {
            this.$swal({type: 'error', title: response.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
    },
    async asyncForEach (array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    },
    checkDeleteselected () {
      if (this.vDataTable.selected.length > 0) {
        this.$swal({
          text: this.$t('WpTestItem.confirmDeleteSelected'),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then((result) => {
          if (result) {
            this.deleteSelected()
          }
        })
      } else {
        this.$swal({type: 'warning', title: this.$t('WpTestItem.messageDeleteNotSelected')})
      }
    },
    async deleteSelected () {
      this.dialog.dialogProgress = true
      this.progressMessage = this.$t('waiting')
      var del = []
      await this.asyncForEach(this.vDataTable.selected, async function (x) {
        this.progressMessage = this.stringFormat(this.$t('WpOrderItem.progressMessageDelete'), x.order_item_desc)
        var val = await this.deleteNode(x)
        if (val !== undefined) {
          del.push(val)
        }
      }.bind(this))
      this.dialog.dialogProgress = false
    },
    async deleteNode (item) {
      try {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/testItem/deleteWpTestItem' + process.env.VUE_APP_DATABASE_TYPE, {
          test_item_id: item.test_item_id
        })
          .then(async response => {
            if (response.data.data[0].reasonValue === 1) {
              this.$swal({type: 'success', title: response.data.data[0].reasonText, showConfirmButton: false, timer: 1500})
              this.retrieveWpTestItem(this.appName)
            } else {
              await this.$swal({type: 'error', title: response.data.data[0].reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
      } catch (e) {
        await this.$swal({type: 'error', title: e.message})
      } finally {
        this.dialog.dialogProgress = false
      }
    },
    async addResultToTest (item) {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/testItem/addResultToTest' + process.env.VUE_APP_DATABASE_TYPE, {
        test_item_skey: this.current_test_item_skey,
        result_item_skey: item.result_item_skey
      }).then(res => {
        if (res.data.isSuccess === true) {
          this.$swal({type: 'success', title: 'สำเร็จ', timer: 1500})
        } else {
          this.$swal({type: 'error', title: 'ไม่สำเร็จ', timer: 1500})
        }
      })
      this.retrieveWpTestItem(this.appName)
      this.dialog.dialogAddResultItem = false
      this.dialog.dialogProgress = false
    },
    addProbeToTest (item) {
      this.addedProbeCd = item.probe_cd
      this.dialog.dialogAddprobeConfirm = true
    },
    async addProbeToTestConfirm () {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/testItem/addProbeToTest' + process.env.VUE_APP_DATABASE_TYPE, {
        test_item_skey: this.current_test_item_skey,
        probe_cd: this.addedProbeCd,
        price: this.addProbePrice,
        remark: this.addProbeRemark
      }).then(res => {
        if (res.data.isSuccess === true) {
          this.$swal({type: 'success', title: 'สำเร็จ', timer: 1500})
          this.addProbePrice = ''
          this.addProbeRemark = ''
          this.addedProbeCd = ''
          this.dialog.dialogAddprobeConfirm = false
        } else {
          this.$swal({type: 'error', title: 'ไม่สามารถเพิ่ม probe ที่มีอยู่แล้วได้', timer: 1500})
        }
      })
      this.retrieveWpTestItem(this.appName)
      this.dialog.dialogProgress = false
    },
    closeAddProbe () {
      this.dialog.dialogAddprobeConfirm = false
    },
    async deleteTestResultItem (resultItem, item) {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/testItem/deleteTestResultItem' + process.env.VUE_APP_DATABASE_TYPE, {
        test_item_skey: item.test_item_skey,
        result_item_skey: resultItem.result_item_skey
      }).then(res => {
        if (res.data.isSuccess === true) {
          this.$swal({type: 'success', title: 'สำเร็จ', timer: 1500})
        } else {
          this.$swal({type: 'error', title: 'ไม่สำเร็จ', timer: 1500})
        }
      })
      this.retrieveWpTestItem(this.appName)
      this.dialog.dialogAddTestItem = false
      this.dialog.dialogProgress = false
    },
    async deleteTestProbe (probe, item) {
      this.dialog.dialogProgress = true
      await this.axios.post(process.env.VUE_APP_API + '/testItem/deleteTestProbe' + process.env.VUE_APP_DATABASE_TYPE, {
        test_item_skey: item.test_item_skey,
        probe_cd: probe.probe_cd
      }).then(res => {
        if (res.data.isSuccess === true) {
          this.$swal({type: 'success', title: 'สำเร็จ', timer: 1500})
        } else {
          this.$swal({type: 'error', title: 'ไม่สำเร็จ', timer: 1500})
        }
      })
      this.retrieveWpTestItem(this.appName)
      this.dialog.dialogAddTestItem = false
      this.dialog.dialogProgress = false
    },
    deleteItemConfirm (item) {
      this.$swal({
        text: this.$t('WpResultItem.confirmDeleteSelected'),
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('no')
      }).then((result) => {
        if (result) {
          this.deleteNode(item)
        }
      })
    },
    editItem (item) {
      this.addEditHeader = this.$t('WpTestItem.editHeader')
      this.newTestItemID = item.test_item_id
      this.newTestItemDesc = item.test_item_desc
      this.newNickName = item.nickname
      this.lab_sub_category_skey = item.sub_category_skey
      this.newCode_p_type = item.code_p_type
      this.isEdit = true
      this.dialog.dialogAddEdit = true
    },
  }
}
</script>
<style scoped>
.style-1 {
  color: rgb(215, 44, 44);
}
.style-2 {
  color: rgb(114,114,67);
}
.sticky-table-footer td {
  font-weight: bold;
  position: sticky;
  bottom: 0;
  background-color: #f8f8f8;
  border-top: thin solid rgba(0,0,0,.12);
}
#vue-editorOrganGrossCustomHeight200 {
  font-family: Arial, Helvetica, sans-serif;
  width: 768px;
  height: 200px;
  caret-color: black;
}
</style>